import { useApiContext, useUpdateInfo } from 'react-easyrocket';
import { SupportedLanguages } from 'src/modules/locales/config';

export const useSetLanguageToProfile = () => {
  const { isAuthenticated } = useApiContext();
  const { mutateAsync: updateProfileInfo } = useUpdateInfo();

  const updateUserInfoForAuth = (lang: SupportedLanguages) => {
    if (!isAuthenticated) return;
    updateProfileInfo({
      language: lang
    });
  };

  return updateUserInfoForAuth;
};
